// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import NodeIndexOutlined from '/root/workspace/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/NodeIndexOutlined';
import HomeOutlined from '/root/workspace/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/HomeOutlined';
import DollarOutlined from '/root/workspace/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DollarOutlined';
import CalendarOutlined from '/root/workspace/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CalendarOutlined';
import SettingOutlined from '/root/workspace/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { NodeIndexOutlined, HomeOutlined, DollarOutlined, CalendarOutlined, SettingOutlined };
